module.exports = __webpack_public_path__ + "static/media/slider1.20124973.jpg";